import React, { useMemo, useCallback, useImperativeHandle, forwardRef } from 'react';
import { Grid } from '@alfa-bank/site-grid-universal';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import styles from '../../styles/styles.css';

import { TopMenuElement } from './top-menu-element';
import type { TTopMenuProps, TMovingHandler, TChildHandler, TClickHandler } from './models';

export const TopMenu = forwardRef<TChildHandler, TTopMenuProps>(
    ({ activeTab, dropDownMapRef, menuGroup, onTabHover, onTabTouch, theme }, parrentRef) => {
        const tabsRefs = useMemo<Record<string, HTMLDivElement | null>>(() => ({}), []);
        const tabHoverHandler = useCallback<TMovingHandler>(
            (e, id, data) => {
                onTabHover();
                Object.keys(tabsRefs).forEach(tabsId => {
                    tabsRefs[tabsId]?.classList.remove(styles.activeElement);
                    dropDownMapRef[tabsId]?.classList.remove(styles.activeDropDown);
                });
                if (tabsRefs[id]) {
                    tabsRefs[id]?.classList.add(styles.activeElement);
                    dropDownMapRef[id]?.classList.add(styles.activeDropDown);
                    if (data) sendEvent(data);
                }
            },
            [dropDownMapRef, onTabHover, tabsRefs]
        );
        const tabClickHandler = useCallback<TClickHandler>((e, data) => {
            if (data) sendEvent(data);
        }, []);

        useImperativeHandle(parrentRef, () => ({
            switchoffActiveTag() {
                Object.keys(tabsRefs).forEach(tabsId => {
                    tabsRefs[tabsId]?.classList.remove(styles.activeElement);

                    dropDownMapRef[tabsId]?.removeAttribute('data-active');
                });
            },
        }));

        return (
            <Grid collapse columnsMargin={0}>
                {menuGroup.map(({ analyticsClick, analyticsHover, id, link, title }) => (
                    <TopMenuElement
                        key={id}
                        activeTab={activeTab}
                        analyticsClick={analyticsClick}
                        analyticsHover={analyticsHover}
                        currentRef={ref => {
                            tabsRefs[id] = ref;
                        }}
                        id={id}
                        link={link}
                        onTabClickHandler={tabClickHandler}
                        onTabHoverHandler={tabHoverHandler}
                        onTabTouchHandler={onTabTouch}
                        theme={theme}
                        title={title}
                    />
                ))}
            </Grid>
        );
    }
);
